<template>
  <div class="pt-editor-help__route-edit">
    <div class="pt-editor-help__tips">
      <div class="pt-editor-help__block">
        <b>ЛКМ</b> - выбор объекта, открытие карточки для редактирования
        параметров объекта
      </div>
      <div class="pt-editor-help__block">
        <b>Backspace</b> - удаление объекта
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["theme"]
};
</script>

<style></style>
